import { EnrollmentMessage, EnrollmentStatus, Learning_Type } from '../enums/_index';
/**
 * Return enrolled message based on enrollment status and learningType
 * Learning type is optional. If there is no learning type, then the enrollment
 * message can still be returned if there is a valid enrollment status.
 * @param learningType - ex - eLearning, Self-study
 * @param status - ex - in_progress
 */
export function getEnrollmentMessage(learningType: string, status: string): string {
  let enrolledMessage = '';
  switch (learningType) {
    case Learning_Type.E_LEARNING:
    case Learning_Type.WEBINAR:
    case Learning_Type.SELF_STUDY:
    case Learning_Type.QUICK_LEARNING:
      if (status === EnrollmentStatus.COMPLETED) {
        enrolledMessage = EnrollmentMessage.REVIEW;
      } else if (status === EnrollmentStatus.IN_PROGRESS) {
        enrolledMessage = EnrollmentMessage.CONTINUE;
      } else if (status === EnrollmentStatus.ENROLLED) {
        enrolledMessage = EnrollmentMessage.START;
      } else if (status === EnrollmentStatus.WAITING) {
        enrolledMessage = EnrollmentMessage.WAITLIST;
      } else {
        // Default Status if the conditions don't match known enrollment status alias
        // if Docebo changes the enrolled status rules
        console.log(`Unknown enrolled status for ${learningType}`, status);
      }
      break;
    // NOTE: Virtual and In-Person is used to show historical or legacy completed or enrolled courses on the dashboard progress only
    // It should not appear in current catalog search or enrollments.
    case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
    case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
    case Learning_Type.INSTRUCTOR_LED:
    case Learning_Type.VIRTUAL:
    case Learning_Type.IN_PERSON:
      if (status === EnrollmentStatus.COMPLETED) {
        enrolledMessage = EnrollmentMessage.VIEW;
      } else if (status === EnrollmentStatus.IN_PROGRESS) {
        enrolledMessage = EnrollmentMessage.CONTINUE;
      } else if (status === EnrollmentStatus.ENROLLED) {
        enrolledMessage = EnrollmentMessage.START;
      } else if (status === EnrollmentStatus.WAITING) {
        enrolledMessage = EnrollmentMessage.WAITLIST;
      } else {
        // Default Status if the conditions don't match known enrollment status alias
        // if Docebo changes the enrolled status rules
        console.log(`Unknown enrolled status for ${learningType}`, status);
      }
      break;
    case Learning_Type.CERTIFICATION_EXAM:
      if (status === EnrollmentStatus.COMPLETED) {
        enrolledMessage = EnrollmentMessage.VIEW_STUDY_GUIDE;
      } else if (status === EnrollmentStatus.IN_PROGRESS) {
        enrolledMessage = EnrollmentMessage.VIEW_STUDY_GUIDE;
      } else if (status === EnrollmentStatus.ENROLLED) {
        enrolledMessage = EnrollmentMessage.VIEW_STUDY_GUIDE;
      } else if (status === EnrollmentStatus.WAITING) {
        enrolledMessage = EnrollmentMessage.VIEW_STUDY_GUIDE;
      } else {
        // Default Status if the conditions don't match known enrollment status alias
        // if Docebo changes the enrolled status rules
        console.log(`Unknown enrolled status for ${learningType}`, status);
      }
      break;
    default:
      // NOTE: If there is no learning types use the status, in case enrollments have null or undefined learning types
      // if Docebo changes the enrolled status rules
      if (status === EnrollmentStatus.COMPLETED) {
        enrolledMessage = EnrollmentMessage.VIEW;
      } else if (status === EnrollmentStatus.IN_PROGRESS) {
        enrolledMessage = EnrollmentMessage.CONTINUE;
      } else if (status === EnrollmentStatus.ENROLLED) {
        enrolledMessage = EnrollmentMessage.START;
      } else if (status === EnrollmentStatus.WAITING) {
        enrolledMessage = EnrollmentMessage.WAITLIST;
      } else {
        // Default Status if the conditions don't match known enrollment status alias
        console.log(`Unknown enrolled status for ${learningType}`, status);
      }
      break;
  }
  return enrolledMessage;
}
